import React from 'react';
import { useDispatch } from 'react-redux';
import { ModalBody, Modal, Button } from "react-bootstrap";
import { togglePhotoBoothUpgrade, togglePlanSection_D } from '../../../../../../actions/showDisplayModalAction';
import { MediaBaseUrl } from '../../../../../../actions/api';

const PhotoBoothUpgrade = ({ show }) => {
    const dispatch = useDispatch();
    const onUpgradeClick = () => {
        dispatch(togglePlanSection_D(true));
    }

    const onCloseClick = () => {
        dispatch(togglePhotoBoothUpgrade(false));
    }

    return <Modal show={show} onHide={onCloseClick} size="lg" aria-labelledby="contained-modal-title-vcenter" centered>
        <ModalBody className="p-md-5 p-4 photobooth-popup-body">
            <div className="row align-itmes-center">
                <h2 className="font-weight-boldest w-100 text-center mt-0 mb-2">Unlock the Photobooth Feature</h2>
                <p className="mb-4 text-center">Make every photo fun and on-brand. Unlock the new Photobooth feature and add custom stickers & funky backgrounds to user photos before they go live.</p>
                <div className="col-lg-12">
                    <div className="switch_image ugc-switch-video mb-3 w-100">
                        <video className={`img-fluid`} autoPlay id="audioTag" loop playsinline muted>
                            <source src={`${MediaBaseUrl}videos/photobooth-video.mp4`} type="video/mp4" />
                        </video>    
                        {/* <img className='w-100' src={`${MediaBaseUrl}images/photobooth/photobooth-upgrade@2x.png`} alt="photobooth-upgrade" /> */}
                    </div>
                </div>
                <div className="col-lg-12">
                    <div className="switch_text_inner text-center">
                        <Button variant="primary" size="lg" onClick={onUpgradeClick} className={`btn-min-w mt-2`}> Upgrade Now </Button>
                    </div>
                </div>
            </div>
        </ModalBody>
    </Modal>
}

export default PhotoBoothUpgrade;